import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["type", "value", "checked", "disabled"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "option-input__hint"
}

import { computed } from 'vue'

import { getImage } from '@/models/onboarding'
import type { QuestionnaireFormOption } from '@/models/onboarding.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'OptionInput',
  props: {
    value: {},
    updateFn: {},
    modelValue: {},
    option: {},
    maxOptions: {},
    type: { default: 'radio' },
    hideInput: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const isChecked = computed(() => {
  return props.modelValue.includes(props.value)
})

const isDisabled = computed(() => {
  if (!props.maxOptions) {
    return false
  }

  return (
    props.type === 'checkbox' &&
    props.modelValue?.length >= props.maxOptions &&
    isChecked.value === false
  )
})

const icon = computed(() => {
  if (!props.option.icon) {
    return
  }
  return getImage(props.option.icon)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "option-input",
    disabled: isDisabled.value
  }, [
    (!__props.hideInput)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: __props.type,
          class: "option-input__input",
          value: __props.value,
          checked: isChecked.value,
          disabled: isDisabled.value,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.updateFn && __props.updateFn(...args)))
        }, null, 40, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["option-input__label-wrapper", {
        'option-input__label-wrapper--has-image': icon.value,
        'option-input__label-wrapper--checkbox': __props.type === 'checkbox',
      }])
    }, [
      (icon.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: icon.value,
            alt: "",
            class: "option-input__icon"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (__props.option.hint)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.option.hint), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1))
}
}

})